import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from 'redux/hooks/reduxHooks';
import { EPageTypes } from 'shared/types/common.interface';
import { openAlertDialog } from 'redux/slices/modals/modals.slice';
import { useEndDebateMutation } from 'redux/api/debate.api';
import { DEBATE_ENDING_OR_LEAVING } from 'shared/constants/alert-constants';
import { DIALOG_CONFIRMATION } from 'shared/constants/modal-constants';
import { LOCAL_STORAGE } from 'shared/constants/local-storage-constants';
import { useLoading } from 'shared/hooks/useLoading';

export const useCheckPage = (currentPage: EPageTypes) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const debateId = localStorage.getItem(LOCAL_STORAGE.currentDebateId);
  const [endDebate, { isLoading: isLoadingEndDebate }] = useEndDebateMutation();

  useLoading(isLoadingEndDebate);

  return async (path: string) => {
    if (currentPage === EPageTypes.debate) {
      await new Promise<boolean>((resolve) => {
        if (resolve) {
          dispatch(
            openAlertDialog({
              title: DIALOG_CONFIRMATION.title,
              text: DIALOG_CONFIRMATION.text,
              сonsentText: DIALOG_CONFIRMATION.сonsentText,
              сonsentCallback: () => {
                endDebate({
                  id: debateId,
                  message: DEBATE_ENDING_OR_LEAVING.youLeft,
                });
                resolve(true);
              },
              dissentText: DIALOG_CONFIRMATION.dissentText,
            }),
          );
        }
      });
    }
    navigate(path);
  };
};
